import Phaser from 'phaser';
import { AudioGate } from '../audio/AudioGate';

export function createIconHud(scene: Phaser.Scene) {
  const depth = 2000;
  const w = scene.scale.width;
  const baseStyle = { fontSize: '22px', color: '#d8f0ff' };
  const mute = scene.add.text(w - 132, 14, '\u266A', baseStyle).setScrollFactor(0).setDepth(depth).setInteractive({ useHandCursor: true });
  const pause = scene.add.text(w - 92, 14, '\u23F8', baseStyle).setScrollFactor(0).setDepth(depth).setInteractive({ useHandCursor: true });
  const restart = scene.add.text(w - 48, 14, '\u21BA', baseStyle).setScrollFactor(0).setDepth(depth).setInteractive({ useHandCursor: true });

  mute.on('pointerdown', () => {
    const m = AudioGate.toggle();
    mute.setAlpha(m ? 0.45 : 1);
  });

  pause.on('pointerdown', () => {
    scene.scene.pause();
    const hint = scene.add.text(w / 2, scene.scale.height / 2, '\u25B6', { fontSize: '64px', color: '#ffffff' }).setOrigin(0.5).setScrollFactor(0).setDepth(depth + 1);
    scene.input.once('pointerdown', () => {
      hint.destroy();
      scene.scene.resume();
    });
  });

  restart.on('pointerdown', () => {
    scene.scene.restart();
  });
}
